// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductDocuments = (client) => ({
    /**
     * `POST /vendor/product-documents/:id/attach`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBulkAttachProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/[id]/attach/route.ts
     */
    attach: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-documents/:id/attach", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/product-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/product-documents", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/product-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-documents/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/product-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductDocuments
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-documents", { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-documents/:id/associations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductDocumentAssociations
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/[id]/associations/route.ts
     */
    listAssociations: (id, query, headers) => client.fetch(buildPath("/vendor/product-documents/:id/associations", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/product-documents/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-documents/:id/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductDocumentSignedUrl
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/[id]/signed-url/route.ts
     */
    retrieveSignedUrl: (id, query, headers) => client.fetch(buildPath("/vendor/product-documents/:id/signed-url", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /vendor/product-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/vendor/product-documents/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-documents/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=product-documents.js.map